(function () {
  function parseMoneyFormat(format, cents) {
    var value = (Number(cents || 0) / 100).toFixed(2);
    var pieces = value.split('.');
    pieces[0] = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    var amount = pieces.join('.');
    return String(format || 'CHF {{ amount }}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function init(root) {
    if (root.dataset.v2Ready === 'true') return;
    root.dataset.v2Ready = 'true';
    document.body.classList.add('vantiq-v2-product');

    var moneyFormat = root.dataset.moneyFormat;
    var ctaPattern = root.dataset.ctaPattern || '[count]';
    var shippingNoteFree = root.dataset.shippingNoteFree || '';
    var shippingNoteSingle = root.dataset.shippingNoteSingle || '';
    var quantityInput = root.querySelector('[data-v2-quantity]');
    var quantityOutput = root.querySelector('[data-v2-qty-output]');
    var variantInput = root.querySelector('.product-variant-id');
    var variantSelect = root.querySelector('[data-v2-variant]');
    var submit = root.querySelector('.v2pdp__cta');
    var unitPrice = root.querySelector('[data-v2-unit-price]');
    var shippingNoteOutput = root.querySelector('[data-v2-shipping-note]');
    var mainImage = root.querySelector('[data-v2-main-image]');
    var zoomLinks = root.querySelectorAll('[data-v2-zoom-link]');
    var imageDialog = root.querySelector('[data-v2-image-dialog]');
    var expandedImage = root.querySelector('[data-v2-image-expanded]');
    var imageClose = root.querySelector('[data-v2-image-close]');
    var variantsNode = root.querySelector('[data-v2-variants]');
    var productForm = root.querySelector('form[data-type="add-to-cart-form"]');
    var deliveryInputs = root.querySelectorAll('[data-v2-delivery]');
    var partnerDialog = root.querySelector('[data-v2-partner-dialog]');
    var partnerSelect = root.querySelector('[data-v2-partner-select]');
    var partnerDetails = root.querySelector('[data-v2-partner-details]');
    var partnerError = root.querySelector('[data-v2-partner-error]');
    var partnerSummary = root.querySelector('[data-v2-partner-summary]');
    var partnerPropertyInputs = root.querySelectorAll('[data-v2-partner-property]');
    var shippingInput = root.querySelector('[data-v2-delivery="shipping"]');
    var testsDialog = root.querySelector('[data-v2-tests-dialog]');
    var variants = [];

    try { variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]'); } catch (error) { variants = []; }

    function selectedVariant() {
      var id = Number(variantInput && variantInput.value);
      return variants.find(function (item) { return Number(item.id) === id; }) || variants[0] || null;
    }

    function syncZoom(url) {
      if (!url) return;
      zoomLinks.forEach(function (link) { link.href = url; });
    }

    zoomLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!imageDialog || !expandedImage || typeof imageDialog.showModal !== 'function') return;
        event.preventDefault();
        expandedImage.src = link.href;
        expandedImage.alt = mainImage ? mainImage.alt : '';
        if (!imageDialog.open) imageDialog.showModal();
      });
    });
    if (imageDialog) {
      imageDialog.addEventListener('click', function (event) {
        if (event.target === imageDialog) imageDialog.close();
      });
    }
    if (imageClose && imageDialog) {
      imageClose.addEventListener('click', function () { imageDialog.close(); });
    }

    function render() {
      var variant = selectedVariant();
      if (!variant) return;
      var quantity = Math.max(1, Number(quantityInput.value || 1));

      quantityInput.value = quantity;
      if (quantityOutput) quantityOutput.textContent = quantity;
      if (unitPrice) unitPrice.textContent = parseMoneyFormat(moneyFormat, variant.price);
      if (shippingNoteOutput) shippingNoteOutput.textContent = quantity < 2 ? shippingNoteSingle : shippingNoteFree;
      if (submit) {
        submit.disabled = !variant.available;
        var label = submit.querySelector('[data-v2-cta]');
        if (label) label.textContent = ctaPattern.replace('[count]', quantity);
      }
    }

    function fittingIsSelected() {
      var selected = root.querySelector('[data-v2-delivery]:checked');
      return selected && selected.dataset.v2Delivery === 'partner';
    }

    function renderPartnerDetails() {
      if (!partnerSelect || !partnerDetails) return;
      var option = partnerSelect.options[partnerSelect.selectedIndex];
      if (!option || !option.value) {
        partnerDetails.hidden = true;
        partnerDetails.textContent = '';
        return;
      }
      var lines = [];
      if (option.dataset.address) lines.push(option.dataset.address);
      if (option.dataset.canton) lines.push(option.dataset.canton);
      if (option.dataset.phone) lines.push(option.dataset.phone);
      if (option.dataset.note) lines.push(option.dataset.note);
      partnerDetails.textContent = lines.join(' · ');
      partnerDetails.hidden = lines.length === 0;
    }

    function showPartnerError() {
      if (!partnerError || !partnerDialog) return;
      partnerError.textContent = partnerDialog.dataset.error || 'Bitte Montagepartner wählen.';
      partnerError.hidden = false;
    }

    function syncPartnerProperties() {
      var option = partnerSelect && partnerSelect.options[partnerSelect.selectedIndex];
      var enabled = !!(fittingIsSelected() && option && option.value);
      partnerPropertyInputs.forEach(function (input) {
        var key = input.dataset.v2PartnerProperty;
        input.disabled = !enabled;
        input.value = enabled ? String(option.dataset[key] || '') : '';
      });
    }

    function openPartnerDialog() {
      if (!partnerDialog || partnerDialog.open) return;
      if (typeof partnerDialog.showModal === 'function') partnerDialog.showModal();
      else partnerDialog.setAttribute('open', '');
    }

    function closePartnerDialog() {
      if (!partnerDialog || !partnerDialog.open) return;
      if (typeof partnerDialog.close === 'function') partnerDialog.close();
      else partnerDialog.removeAttribute('open');
    }

    function updateDelivery(openDialog) {
      if (!partnerDialog || !partnerSelect) return;
      var showPartners = fittingIsSelected();
      partnerSelect.disabled = !showPartners;
      partnerSelect.required = showPartners;
      if (!showPartners && partnerError) {
        partnerError.hidden = true;
        partnerError.textContent = '';
        closePartnerDialog();
      }
      if (showPartners && openDialog) openPartnerDialog();
      syncPartnerProperties();
      renderPartnerDetails();
    }

    root.querySelectorAll('[data-v2-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.v2QtyStep || 0));
        render();
      });
    });

    root.querySelectorAll('[data-v2-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!mainImage || !button.dataset.image) return;
        mainImage.src = button.dataset.image;
        mainImage.removeAttribute('srcset');
        syncZoom(button.dataset.zoom);
        root.querySelectorAll('[data-v2-thumb]').forEach(function (item) { item.setAttribute('aria-current', 'false'); });
        button.setAttribute('aria-current', 'true');
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        variantInput.value = option.value;
        if (mainImage && option.dataset.image) {
          mainImage.src = option.dataset.image;
          mainImage.removeAttribute('srcset');
          syncZoom(option.dataset.zoom);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
        render();
      });
    }

    deliveryInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateDelivery(input.dataset.v2Delivery === 'partner');
      });
    });

    if (partnerSelect) {
      partnerSelect.addEventListener('change', function () {
        if (partnerError) {
          partnerError.hidden = true;
          partnerError.textContent = '';
        }
        syncPartnerProperties();
        renderPartnerDetails();
      });
    }

    root.querySelectorAll('[data-v2-partner-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!partnerSelect.value && shippingInput) shippingInput.click();
        closePartnerDialog();
      });
    });

    var partnerApply = root.querySelector('[data-v2-partner-apply]');
    if (partnerApply) {
      partnerApply.addEventListener('click', function () {
        if (!partnerSelect.value) {
          showPartnerError();
          partnerSelect.focus();
          return;
        }
        var option = partnerSelect.options[partnerSelect.selectedIndex];
        if (partnerSummary && option) partnerSummary.textContent = option.dataset.summary || option.textContent;
        syncPartnerProperties();
        closePartnerDialog();
      });
    }

    if (partnerDialog) {
      partnerDialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        if (!partnerSelect.value && shippingInput) shippingInput.click();
        closePartnerDialog();
      });
      partnerDialog.addEventListener('click', function (event) {
        if (event.target !== partnerDialog) return;
        if (!partnerSelect.value && shippingInput) shippingInput.click();
        closePartnerDialog();
      });
    }

    root.querySelectorAll('[data-v2-tests-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!testsDialog || testsDialog.open) return;
        if (typeof testsDialog.showModal === 'function') testsDialog.showModal();
        else testsDialog.setAttribute('open', '');
      });
    });

    root.querySelectorAll('[data-v2-tests-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!testsDialog || !testsDialog.open) return;
        if (typeof testsDialog.close === 'function') testsDialog.close();
        else testsDialog.removeAttribute('open');
      });
    });

    if (testsDialog) {
      testsDialog.addEventListener('click', function (event) {
        if (event.target !== testsDialog) return;
        if (typeof testsDialog.close === 'function') testsDialog.close();
        else testsDialog.removeAttribute('open');
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        syncPartnerProperties();
        if (!fittingIsSelected() || !partnerSelect || partnerSelect.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showPartnerError();
        openPartnerDialog();
        partnerSelect.focus();
      }, true);
    }

    updateDelivery(false);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-vantiq-product-v2]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
